import { render, staticRenderFns } from "./Subtopics.vue?vue&type=template&id=a2df6152&scoped=true&"
import script from "./Subtopics.vue?vue&type=script&lang=js&"
export * from "./Subtopics.vue?vue&type=script&lang=js&"
import style0 from "./Subtopics.vue?vue&type=style&index=0&id=a2df6152&lang=scss&scoped=true&"
import style1 from "./Subtopics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2df6152",
  null
  
)

export default component.exports